import { parameters as URLParameters } from '@elab/core/utils/url';

export const getLoginRedirectURL = () => {
    const redirectURL = new URL('/login', window.location.origin);
    redirectURL.searchParams.set(URLParameters.REDIRECT_TYPE, 'history');
    return redirectURL.toString();
};
